// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const ExpiredPassword = () => {

   const [text, set_text] = React.useState();

   var content    = [];

   var key_index  = 1;

   const showpass = React.useRef();
   const passtext = React.useRef();
   const password = React.useRef();
   const username = React.useRef();
   const verify   = React.useRef();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      content.push(<p className="ask-henry-body-margin-bottom-x" key={key_index++}>Enter your user identifier and password:</p>);
      content.push(<input className="ask-henry-form-input" placeholder="User identifier. . ." key={key_index++} ref={username} type="text" />);
      content.push(<input className="ask-henry-form-input ask-henry-form-password" key={key_index++} placeholder="Current Password. . ." ref={password} type="password" />);

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           {warn}
           {content}
           <p className="ask-henry-body-margin-bottom-x">Enter and verify new password:</p>
           <input className="ask-henry-form-input ask-henry-form-password" placeholder="New Password. . ." ref={passtext} type="password" />
           <input className="ask-henry-form-input ask-henry-form-password" placeholder="Verify Password. . ." ref={verify} type="password" />
           <input className="ask-henry-checkbox" onChange={(e) => build_checkbox_click(e)} ref={showpass} type="checkbox" /> Show passwords
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Reset Password</button>
         </>
      );

   } // build();

   const build_checkbox_click = (e) => {
      const list = document.getElementsByClassName('ask-henry-form-password');
      for (var ith = 0; ith < list.length; ith++) {
         list[ith].type = e.target.checked ? 'text' : 'password';
      }
   }; // build_checkbox_click();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;

      if (!username.current?.value || !password.current?.value || !passtext.current?.value || !verify.current?.value) {
         set_warn('Enter all fields given bellow:');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else if (passtext.current?.value !== verify.current?.value) {
         set_warn('Make sure the new and verify passwords are the same.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }

   } // check();

   const enact = async ({ set_body, set_foot, set_form, set_warn, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      var body     = ''
      + 'username='  + username.current?.value 
      + '&password=' + password.current?.value
      + '&passtext=' + passtext.current?.value
      + '&passuser=' + username.current?.value
      ;
      var response = await api.fetch('sys/password', api.post(body), api.token());

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
            // 'The password must be between eight and 20 characters long, must contain at least one upper case character, one lower case character, one number and one of these special characters: ! @ # $ % & * + ?'
         }
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {


         body     ='username=' + username.current?.value + '&password=' + passtext.current?.value;

         var response = await api.fetch('sys/auth/user', api.post(body));

         if (!response.good) {

            if ('undefined' === typeof response.data.text) {
               set_warn('Unrecognized error returned from API.');
            } else {
               if ('User password has expired.' === response.data.text) {
                  app.set_state('mode', 'ExpiredPassword', false);
                  app.set_state('user_id', -1);
               } else {
                  set_warn(response.data.text);
               }
            }
            set_form(FORM.BUILD);

         } else {

            app.state.access_token = response.data.access_token;
            app.state.is_admin     = response.data.user.is_admin;
            app.state.name_full    = response.data.user.name_first + ' ' + response.data.user.name_last;
            app.state.role         = '';
            app.state.user_id      = response.data.user.user_id;
            app.state.user_name    = response.data.user.user_name;

            response = await api.fetch('dbs/user/access', api.token());

            if (!response.good) {
            } else {
               app.state.user_access_id = 0;
               if (response.data.user_access_list) {
                  const list = response.data.user_access_list;
                  app.state.user_access_list = list;
                  app.state.application_id   = list[0].application_id;
                  app.state.version_id       = list[0].version_id;
                  app.state.status           = app.state.name_full + ' logged into system'
               } else {
                 app.state.user_access_list = [];
                  app.state.application_id   = 0;
                  app.state.version_id       = 0;
               }
               set_form(FORM.FINAL);
               app.set_state('mode', null);
            }

         }

         set_form(FORM.FINAL);
         var text = response.data.message;
         set_text(text);
         app.set_state('status', text);
      }

   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">{text}</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close}>Close</button>);
   } // final();

   return <Form build={build} check={check} enact={enact} final={final} title="Reset Expired Password" />

} // <ExpiredPassword />

export default ExpiredPassword;
